import { LICENSE_STATUS } from '../constants/license';

export default {
  translation: {
    general: {
      loading: 'Caricamento...',
      today: 'Oggi'
    },
    header: {
      users: 'Utenti',
      quiz: 'Test',
      questions: 'Domande',
      statistics: 'Statistiche',
      coachAI: 'Edulai Coach AI',
      skills: 'Skills e Sotto skills',
      settings: 'Impostazioni',
      domain: 'Informazioni dominio'
    },
    skills: {
      COLLABORATION: 'Collaborazione',
      CRITICAL_THINKING: 'Pensiero Critico',
      PROBLEM_SOLVING: 'Problem Solving',
      LEADERSHIP: 'Leadership',
      COMMUNICATION: 'Comunicazione',
      INTERCULTURALISM: 'Interculturalità',
      LEARNING: 'Apprendimento',
      systemSkills: 'Skills di sistema',
      createNewSkill: 'Nuova Skill',
      noSkillFound: 'Nessuna Skill trovata a sistema',
      systemSubSkill: 'Sotto-Skill',
      noSubSkillForSkill: 'Nessuna Sub-Skill definita per la Skill selezionata',
      systemSubSkills: 'Sotto-Skills',
      systemSubSkillsDescription: 'Definisci una o più Sotto-Skill associate alla Skill corrente'
    },
    skillsReport: {
      reportIntroductionTitle: 'Introduzione',
      reportIntroduction:
        'Edulai Skills Checker© è un software del pacchetto Edulai concepito per misurare le competenze degli utenti, attraverso la somministrazione di casi professionali specifici.\n\n Lo scopo di Edulai Skills Checker© è quello di valutare su una scala da 1 (base) a 5 (esperto) il livello delle competenze e delle sotto competenze trasversali possedute, strumenti chiave oggi per il mercato del lavoro del futuro.\n\n Lo Skills Checker© sottopone dei Casi professionali che l’utente dovrà risolvere scegliendo una risposta tra diverse opzioni possibili, riflettendo sui comportamenti che possono essere più vicini alla propria esperienza personale o che utilizzerebbe calandosi nelle diverse situazioni \n\n',
      reportSkillsListIntro: 'Le Competenze valutate da questo Test sono le seguenti:',
      reportSkillsValueListIntro:
        'La scala utilizzata per la valutazione comprende i seguenti livelli/stelle per ogni competenza:',
      reportIntroductionEnd:
        'Una volta effettuata la valutazione, il sistema offre accesso ad un manuale guida per la lettura dei propri risultati e delle definizioni delle competenze.',
      reportIntroductionSkillsValue:
        '• 1 stella – Base\n• 2 stelle – Principiante\n• 3 stelle – Intermedio\n• 4 stelle – Avanzato\n• 5 stelle – Esperto',
      skillsResultsTitle: 'RISULTATI SKILLS CHECKER PER OGNI COMPETENZA & SOTTO-COMPETENZA',
      skillsChartResultsTitle: 'RISULTATI SKILLS CHECKER',
      skillsResultsValueTitle: 'VALORE DI RIFERIMENTO (1-5)',
      strengths: 'Punti di forza',
      weaknesses: 'Aree da potenziare',
      areasDevelopments: 'Ambiti di sviluppo',
      noWeaknesses: 'Il report non mostra al momento attuale aree particolari da potenziare.',
      noStrengths: 'Il report non mostra al momento particolari punti di forza da segnalare.',
      noAreasDevelopments: 'Il report non mostra al momento attuale ambiti di sviluppo.'
    },
    login: {
      noService: 'Servizio temporaneamente non disponibile. Per favore ricarica la pagina e riprova',
      welcome: 'Bentornato!',
      passwordRecovery: 'Password dimenticata?',
      passwordRecoveryBody:
        "Inserisci la tua email nel campo sottostante. Ti invieremo un'email con le istruzioni per il recupero password",
      loginError: 'Login fallito. Per favore controlla le tue credenziali e riprova',
      welcomeFirstTime: 'Imposta la tua password per accedere',
      confirmRegistrationError: "Si è verificato un errore nella creazione dell'account. Per favore riprova",
      creatingYourAccount: 'Stiamo creando il tuo nuovo account!',
      createAccountSuccess:
        'Account creato con successo. Controlla la tua posta elettronica per impostare la password ed effettuare il login',
      resetPasswordSuccess: "Un'email con le istruzioni di recupero è stata inviata!",
      resetPasswordError: 'Si è verificato un errore nel recupero password. Per favore riprova',
      passwordSetSuccess: 'Password impostata con successo! Vai al login per accedere',
      passwordSetError: "Si è verificato un errore nell'impostare la password. Per favore riprova",
      insertEmail: 'La tua email',
      insertPassword: 'La tua password',
      registerNow: 'Non hai un account? Registrati adesso!',
      registerUserBody: 'Inserisci i tuoi dati per creare il tuo account Edulai!',
      registerUserEmail: "Ti invieremo un'email con le istruzioni per impostare la tua password",
      createNewAccount: 'Crea un nuovo account',
      insertFirstName: 'Il tuo nome',
      insertLastName: 'Il tuo cognome',
      acceptPrivacy: 'Ho letto e accetto la Privacy Policy',
      passwordRecoveryForUser: 'Invia email di recupero password'
    },
    modals: {
      cancel: 'Cancella',
      continue: 'Continua',
      confirm: 'Conferma',
      ok: 'Ok',
      compliment: 'Complimenti',
      publish: 'Pubblica',
      close: 'Chiudi',
      delete: 'Elimina',
      save: 'Salva',
      reloadPage: 'Ricarica Pagina',
      closeWithoutSave: 'Chiudi senza salvare'
    },
    languages: {
      language: 'Lingua',
      it: 'Italiano',
      en: 'Inglese',
      ITALIAN: 'Italiano',
      ENGLISH: 'Inglese',
      selectLanguage: 'Seleziona lingua'
    },
    user: {
      profile: 'Profilo',
      ageRange: "Fascia d'età",
      gender: 'Genere',
      nation: 'Nazione',
      employment: 'Impiego',
      professionName: 'Professione',
      experienceAgeRange: 'Anni di esperienza',
      educational: 'Livello istruzione',
      portfolioDescription: 'Portfolio',
      employmentsTypes: {
        STUDENT: 'Studente',
        UNEMPLOYED: 'Disoccupato',
        EMPLOYED: 'Impiegato'
      },
      ageRangeTypes: {
        RANGE18_22: '18-22 anni',
        RANGE23_25: '23-25 anni',
        RANGE26_30: '26-30 anni',
        RANGE31_40: '31-40 anni',
        RANGE41_50: '41-50 anni',
        RANGE51_99: '50+ anni'
      },
      experienceAgeRangeTypes: {
        RANGE0_1: 'Meno di un anno',
        RANGE1_2: '1-2 anni',
        RANGE2_5: '2-5 anni',
        RANGE5_10: '5-10 anni',
        RANGE10_20: '10-20 anni',
        RANGE20_99: 'Più di 20 anni'
      },
      genderTypes: {
        MALE: 'Maschio',
        FEMALE: 'Femmina',
        UNSPECIFIED: 'Non specificato'
      },
      educationalTypes: {
        SECONDARY_SCHOOL: 'Scuola superiore',
        GRADUATION: 'Diploma/Laurea Universitaria',
        POSTGRADUATE_CERTIFICATE: 'Certificazione post-universitaria'
      },
      onboardingUpdatedAt: 'Profilo aggiornato al {{date}}'
    },
    forms: {
      copySuccess: 'Link copiato negli appunti',
      inactiveUserActivationLink: 'Link di attivazione',
      inactiveUserExplanation: "L'utente non ha ancora attivato il suo account",
      inactiveUserCopyLink:
        "Se l'utente ha difficoltà ad attivare il suo account puoi inviargli questo link di attivazione",
      inactiveUserCopyWarning:
        "Attenzione: utilizza questo link solo in casi di estrema necessità. Verifica che l'utente abbia inserito un'email valida e di star inviando il link all'account corretto. Una volta in possesso del link di attivazione, chiunque potrà attivare questo account anche in maniera erronea",
      selectSkill: 'Seleziona una skill',
      today: 'Oggi',
      thisMonth: 'Questo mese',
      thisYear: "Quest'anno",
      last6Months: 'Ultimi 6 mesi',
      thisWeek: 'Questa settimana',
      edulaiTagNotModify: 'Il gruppo Edulai non può essere modificato',
      tagName: 'Nome gruppo',
      selectAtLeastOneSkillToCreateAnswers:
        'Seleziona almeno una skill e una sottoskill per iniziare a creare le risposte',
      badgeLinksDescription: 'Link a badge digitali',
      forceUserOnboardingDescription: "Forza l'utente ad effettuare nuovamente l'onboarding",
      forceUserOnboarding: 'Forza onboarding',
      enableUser: 'Attiva utente',
      selfAssessmentDescription:
        'Indica il livello di padronanza che ritieni di avere per ogni skill indicando un valore da 1 a 5, dove 1 indica il livello Base e 5 quello di Esperto',
      saveDraft: 'Salva bozza test',
      backtoLogin: 'Torna al login',
      noOptions: 'Nessuna opzione',
      loadingOptions: 'Caricando opzioni',
      companyRolePlaceholder: 'Cerca ruolo...',
      companyLicensePlaceholder: 'Cerca licenza...',
      required: 'Obbligatorio',
      save: 'Salva',
      search: 'Cerca',
      reset: 'Cancella',
      name: 'Nome',
      edit: 'Modifica',
      send: 'Invia',
      createNew: 'Crea',
      saveChanges: 'Salva modifiche',
      firstName: 'Nome',
      lastName: 'Cognome',
      next: 'Prossimo',
      back: 'Indietro',
      skip: 'Salta',
      finish: 'Finito',
      optional: 'Opzionale',
      confirmPassword: 'Conferma password',
      newPassword: 'La tua password',
      passwordValidation: 'Minimo 8 caratteri e almeno una lettera. Non utilizzare caratteri speciali',
      passwordMustCoincide: 'Le password devono coincidere',
      passwordSpecialCharacters: 'Nessun carattere speciale',
      warning: 'Attenzione',
      close: 'Chiudi',
      emailNotValid: 'Email non valida',
      logoutConfirmation: 'Sei sicuro di voler effettuare il logout?',
      insertFirstName: 'Il tuo nome',
      insertLastName: 'Il tuo cognome',
      iAcceptThe: 'Ho letto e accetto la',
      privacyPolicy: 'Privacy Policy',
      confirmPasswordLabel: 'Conferma la tua password',
      confirmRegistration: 'Crea il tuo account',
      confirmPasswordTitle: 'Conferma password',
      userRole: 'Ruolo utente',
      userLicense: 'Licenza Utente',
      deleteUser: 'Cancella utente',
      disableUserExplanation: "Disabilita l'utente per revocare tutti i suoi permessi all'interno della piattaforma",
      enabledUserExplanation: "L'utente è stato disabilitato",
      userStatus: "Stato dell'utente",
      onboardingTitle: 'Benvenuto in Edulai!',
      onboardingDescription:
        'Ti diamo il nostro benvenuto in <strong>Edulai Skills Checker</strong> Prima di iniziare ti chiediamo un paio di minuti per conoscerti meglio. Come valuti le tue competenze? Prenditi il tuo tempo per rispondere e sii sincero con te stesso. Adesso cominciamo!',
      whatIsYourAge: 'Quanti anni hai?',
      startEdulai: 'Comincia a usare Edulai!',
      whatIsYourGender: 'Qual è il tuo genere?',
      male: 'Uomo',
      female: 'Donna',
      other: 'Altro',
      insertNation: 'Inserisci la tua nazione',
      whatIsYourNation: 'Qual è la tua nazione di residenza?',
      whatIsYourOccupancy: 'Attualmente sei',
      student: 'Studente',
      unemployed: 'Disoccupato',
      professionist: 'Un professionista occupato',
      whatIsYourJob: 'Se sei occupato, qual è il nome del tuo ruolo professionale principale?',
      insertJobTitle: 'Inserisci il nome del tuo ruolo',
      yearsOfExperince: 'Quanti anni di esperienza professionale hai in quel ruolo?',
      insertYearsOfExperince: 'Inserisci anni di esperienza',
      years: 'Anni',
      lessThanOneYear: 'Meno di un anno',
      moreThanTwentiYear: 'Più di 20 anni',
      whatIsYourScholarLevel: 'Qual è il tuo livello scolastico?',
      highSchool: 'Scuola superiore',
      universityDegree: 'Diploma/Laurea Universitaria',
      postUniversityDegree: 'Certificazione post-universitaria',
      stageOrInsterests:
        "Hai mai svolto stage di qualunque tipo, studi o lavoro all'estero, o hai degli interessi personali che ti hanno aiutato a sviluppare delle competenze per il mercato del lavoro? In caso affermativo seleziona le competenze che hai maturato e spiega qui sotto attraverso quale esperienze sono state acquisite. Se del caso potrai discutere queste competenze direttamente con i datori di lavoro",
      stageOrInsterestsSupport:
        'Indica in questa casella se hai del materiale prodotto a supporto delle competenze maturate che hai elencato qui sopra, come parte del tuo portfolio professionale da mostrare ai datori di lavoro ed indica di che materiale si stratta (Es. registrazioni video di tue presentazioni, elaborati scritti o progetti da te realizzati, etc)',
      stageOrInsterestsBadges:
        'Hai mai ottenuto badge digitali o certificazioni per una o più delle competenze qui sopra riportate? In caso affermativo indica per quale/quali competenza/competenze li hai maturati? Fornisci per favore qui sotto anche il/i link al/ai badge, se del caso',
      skillName: 'Nome skill',
      newSkillWarning:
        'La nuova skill sarà disponibile solo per la creazione o la modifica di nuove domande. Le modifiche non coinvolgeranno Test già creati o in corso',
      skillCreatedSuccess: 'Skill creata con successo',
      skillCreatedError: 'Si è verificato un errore nella creazione della Skill. Per favore riprova',
      skillUpdatedSuccess: 'Skill aggiornata con successo',
      skillUpdatedError: "Si è verificato un errore nell'aggiornamento della Skill. Per favore riprova",
      skillDeleteWarning:
        "Eliminando questa Skill, la renderai non disponibile per i nuovi Test. Test precedenti che includono questa Skill non saranno interessati da questo cambiamento e l'abilità sarà comunque visibile nelle statistiche",
      skillDeleteError: 'Si è verificato un errore nella cancellazione della Skill. Per favore riprova',
      skillDeleteSuccess: 'Skill cancellata con successo',
      subSkills: 'Sub-Skills',
      newSubSkill: 'Nuova Sub-Skill',
      subSkillCreatedSuccess: 'Sub-Skill creata con successo',
      subSkillCreatedError: 'Si è verificato un errore nella creazione della Sub-Skill. Per favore riprova',
      subSkillUpdatedSuccess: 'Sub-Skill aggiornata con successo',
      subSkillUpdatedError: "Si è verificato un errore nell'aggiornamento della Sub-Skill. Per favore riprova",
      subSkillDeleteWarning:
        "Eliminando questa Sub-Skill, la renderai non disponibile per i nuovi Test. Test precedenti che includono questa Sub-Skill non saranno interessati da questo cambiamento e l'abilità sarà comunque visibile nelle statistiche",
      subSkillDeleteError: 'Si è verificato un errore nella cancellazione della Sub-Skill. Per favore riprova',
      subSkillDeleteSuccess: 'Sub-Skill cancellata con successo',
      deleteSubSkill: 'Cancella Sotto-Skill',
      deleteSkill: 'Cancella Skill',
      expirationDate: 'Data di scadenza',
      creationDate: 'Data di creazione',
      credits: 'Crediti residui',
      subscriptionType: 'Tipo di licenza',
      addCredits: 'Aggiungi crediti',
      setCredits: 'Imposta crediti',
      totalCredits: 'Crediti totali',
      addCreditsDescription: "Modifica i crediti dell'istituzione",
      addCreditSuccess: 'Crediti modificati con successo',
      addCreditError: 'Si è verificato un errore nella modifica dei crediti. Per favore riprova',
      creditsLabel: 'Crediti',
      modifyDomainType: 'Modifica tipo di licenza',
      modifyDomainTypeDescription:
        'Puoi modificare il tipo di lincenza dominio in Licenza Flat (crediti illimitati) e Licenza PPU (crediti limitati).',
      modifyDomainTypeWarning: 'Sei sicuro di voler modificare la licenza?',
      modifyDomainTypeSuccess: 'Licenza modificata con successo',
      modifyDomainTypeError: 'Si è verificato un errore nella modifica della licenza. Per favore riprova',
      flatSubscriptionDescription: 'Flat (crediti illimitati)',
      ppuSubscriptionDescription: 'PPU (crediti limitati)',
      flatCreditsDescription:
        'Nei domini di tipo FLAT i crediti residui non verranno scalati quando vengono inviate nuove rispose ai Test',
      domainStatus: 'Stato Dominio',
      disabled: 'Disabilitato',
      enabled: 'Attivo',
      disableDomain: 'Disabilita Dominio',
      enableDomain: 'Attiva Dominio',
      disableDomainRequest:
        'Sei sicuro di voler disattivare il dominio? Non sarà più possibile creare nuovi utenti, nuovi Test e sottomettere risposte',
      modifyDomainStatusSuccess: 'Stato del dominio modificato con successo',
      modifyDomainStatusError: 'Si è verificato un errore nella modifica del dominio.',
      title: 'Titolo',
      text: 'Testo',
      evaluatedSkills: 'Skills valutate',
      startDate: 'Data di inizio',
      startTime: 'Ora di inizio',
      startDateTime: 'Date e ora di inizio',
      endDate: 'Data di fine',
      endTime: 'Ora di fine',
      endDateTime: 'Date e ora di fine',
      min1hr: 'Intervallo minimo di 1 ora',
      startBeforeEnd: 'Data di inizio successiva a data di fine',
      newEndBeforeOldEnd: 'Nuova data di fine predecente ad originale',
      quizInPast: 'Impossibile creare test nel passato',
      delete: 'Elimina',
      total: 'Totale',
      totals: 'Totali',
      creditsAfterOperations: "Crediti totali dopo l'operazione: {{credits}}",
      selectOperation: 'Seleziona operazione',
      modifyCredits: 'Modifica Crediti',
      userTagPlaceholder: "Seleziona un gruppo per l'utente",
      userTag: 'Gruppo utente',
      userTagDescription: 'Utilizza i gruppi per permettere di selezionare più utenti in maniera semplice',
      createNewOption: 'Crea nuovo',
      createNewTagDescription: 'Crea un nuovo gruppo per gli utenti',
      createNewTag: 'Crea nuovo gruppo',
      modifyTagDescription: 'Modifica il gruppo di utenti',
      deleteTagConfirm: "Sei sicuro di voler eliminare questo gruppo? L'operazione non può essere annullata",
      dateInterval: 'Intervallo di tempo',
      applyFilters: 'Applica filtri',
      resetFilters: 'Elimina filtri',
      stageOrInsterestsDescription: 'Abilità e esperienza in stage',
      edulaiTagDefaultDescription: "Se non selezioni nessun gruppo, l'utente apparterrà al gruppo di base Edulai",
      editSkillName: 'Modifica nome skill',
      cantDeleteReferencedSkill:
        'Impossibile eliminare la skill selezionata. La skill è referenziata da una o più domande.',
      deleteQuestionWarning:
        'Eliminando questa Domanda la renderai non disponibile per i nuovi Test. Test che includono una versione precedente di questa Domanda non saranno interessati da questo cambiamento.',
      deleteQuestionSuccess: 'Domanda eliminata',
      deleteQuestionError: 'Si è verificato un errore nella cancellazione della domanda',
      deleteQuestionInUseError: 'Errore: questa versione della domanda è in uso in un Test',
      maxCharacters: 'Massimo {{number}} caratteri'
    },
    domainTypes: {
      FLAT: 'Licenza FLAT',
      PPU: 'Licenza a consumo crediti'
    },
    users: {
      inactiveUser: 'Utenti inattivi',
      tagUsers: 'Utenti',
      deleteTagSuccess: 'Gruppo eliminato',
      deleteTagError: 'Si è verificato un errore nel cancellare il gruppo',
      createUserTagSuccess: 'Gruppo creato con successo',
      createUserTagError: 'Si è verificato un errore nella creazione del gruppo',
      editUserTagSuccess: 'Gruppo modificato',
      editUserTagError: 'Si è verificato un errore nella modifica',
      userData: 'Dati utente',
      userProfile: 'Profilo utente',
      platformUsers: 'Utenti piattaforma',
      createNewUser: 'Nuovo utente',
      userEmail: "Email dell'utente",
      noUsersFound: 'Nessun utente trovato',
      disabled: 'Disabilitato',
      disableUser: 'Disabilita utente',
      enabled: 'Attivo',
      userModifySuccess: 'Profilo aggiornato con successo',
      userCreationError: "Si è verificato un errore nella creazione dell'utente. Per favore riprova",
      userDeleteError: "Si è verificato un errore nella cancellazione dell'utente. Per favore riprova",
      userModifyError: "Si è verificato un errore nella modifica dell'utente. Per favore riprova",
      modifyUserSuccess: 'Utente modificato con successo',
      createUserSuccess:
        "Utente creato con successo, L'utente risulterà INATTIVO fin quando non attiverà il suo account creando la sua password personale",
      deleteUserConfirm: "Sei sicuro di voler eliminare l'utente selezionato? L'operazione non può essere annullata",
      userDeleteSuccess: 'Utente eliminato con successo',
      platformUser: 'Utente piattaforma',
      disableUserSuccess: 'Utente disabilitato con successo',
      enableUserSuccess: 'Utente abilitato con successo',
      disableUserError: 'Si è verificato un errore. Per favore riprova',
      resendConfirmationEmail: 'Reinviga email di conferma',
      resendActivationEmail: 'Invia email di attivazione',
      activeUsers: 'Utenti attivi',
      disabledUsers: 'Utenti disabilitati',
      onboardingFailed: "Si è verificato un errore nell'invio dei dati. Per favore riprova",
      usersTags: 'Gruppi di utenti',
      noUsersTagFound: 'Nessun gruppo trovato',
      inactive: 'Inattivo'
    },
    questions: {
      newQuestion: 'Nuova domanda',
      editQuestion: 'Modifica domanda',
      findInTitle: 'Cerca nel titolo',
      noQuestionsFound: 'Nessuna domanda trovata',
      createQuestionSuccess: 'Domanda creata con successo',
      createQuestionError: 'Si è verificato un errore durante la creazione della domanda. Per favore riprova.',
      modifyQuestionSuccess: 'Domanda modificata con successo',
      modifyQuestionError: 'Si è verificato un errore durante la modifica della domanda. Per favore riprova.',
      answers: 'Risposte',
      newAnswer: 'Nuova risposta',
      editAnswer: 'Modifica riposta',
      deleteOptionConfirm: "Sei sicuro di voler eliminare l'opzione selezionata? L'operazione non può essere annullata",
      optionDeleteSuccess: 'Opzione eliminata con successo',
      optionsNumberError: 'Per favore, inserire almeno 3 risposte valide.',
      firstOptionCreate:
        'Dopo aver creato la prima risposta non sarà più possibile modificare skills e sottoskills senza resettare tutte le risposte già create. Sei sicuro di voler procedere?',
      myAnswers: 'Le mie risposte',
      version: 'Versione'
    },
    roles: {
      ROOT: 'Root',
      ADMIN: 'Admin',
      SUPERVISOR: 'Supervisore',
      USER: 'Utente base',
      PRINCIPAL: 'Principal'
    },
    license: {
      TRIAL: 'Prova',
      PRO: 'Pro'
    },
    rolesDescriptions: {
      ROOT: 'Questo ruolo è dedicato ai gestori della piattaforma cloud di Edulai',
      ADMIN:
        "L'utente Admin è l'utenza di più alto livello gerarchico dell'istituzione ed è responsabile della gestione degli utenti della piattaforma,",
      PRINCIPAL:
        "Il Principal è l'amministratore dell'istituzione il cui scopo è visualizzare l'andamento dello svolgimento dei test e l'avanzamento delle skills di tutta l'istituzione",
      SUPERVISOR:
        "L'utente Supervisor è l'utente di backoffice dell'istituzione il cui compito è creare e somministrare test",
      USER: "L'utente base della piattaforma ha la possibilità di compilare test, visualizzare i propri risultati per un singolo test e vedere l'andamento delle sue Skills e Sotto-Skills dal suo profilo"
    },
    licenseDescriptions: {
      TRIAL:
        'L’utente Trial ha accesso completo alla piattaforma e alle funzionalità AI per 7 giorni, per esplorare tutte le potenzialità del sistema prima dell’attivazione della licenza Pro.',
      PRO: 'L’utente Pro dispone di tutte le funzionalità della piattaforma e dell’AI per il periodo di attivazione definito, con accesso completo e continuativo a tutti i servizi.'
    },
    licenseTooltip: {
      [LICENSE_STATUS.EXPIRED]: 'Licenza scaduta il {{formattedDate}}',
      [LICENSE_STATUS.WARNING]: 'Licenza in scadenza il {{formattedDate}}'
    },
    domain: {
      domain: 'Dominio',
      customFields: 'Campi anagrafici personalizzati',
      createCustomField: 'Crea campo anagrafico',
      customFieldDescription: 'Questo campo anagrafico verrà mostrato agli utenti come domanda in fase di onboarding',
      customFieldTitle: 'Nome del campo anagrafico',
      customFieldBody: 'Testo della domanda',
      customFieldSuccess: 'Campi anagrafici modificati con successo',
      customFieldError: 'Si è verificato un errore nella modifica dei campi anagrafici',
      deleteCustomFieldRequest: "Sei sicuro di voler eliminare questo campo? L'operazione non può essere annullata",
      customFieldDeleteSuccess: 'Campo eliminato con successo',
      customFieldDeleteError: "Si è verificato un errore nell'eliminazione"
    },
    quizzes: {
      types: {
        DRAFT: 'BOZZA',
        RUNNING: 'ATTIVO',
        PAUSED: 'IN PAUSA',
        DONE: 'FINITO',
        READY: 'PRONTO',
        ALL: 'TUTTI',
        EXPIRED_FOR_USER: 'SCADUTO'
      },
      typesDescriptions: {
        DRAFT: 'Le bozze dei test possono essere modificati. Clicca per attivarlo!',
        RUNNING: 'Il test è attivo e gli utenti possono rispondere alle domande',
        PAUSED: 'Il test è in pausa e gli utenti non possono rispondere alle domande',
        DONE: 'Il test è terminato!',
        READY: 'Il Test inizierà quando passerà la sua ora di inizio o se avviato prima del tempo',
        EXPIRED_FOR_USER: 'Il test è terminato e non hai inviato le tue risposte'
      },
      selectSupervisor: 'Seleziona un Supervisore',
      selectSupervisorDescription: 'Se non selezioni un supervisore solo tu sarai in grado di gestire il Test!',
      noCreditsError: 'Crediti del dominio terminati! Aggiungi nuovi crediti per avviare i test!',
      activeQuizzes: 'Test attivi',
      disabledQuizzes: 'Test inattivi',
      newQuiz: 'Nuovo test',
      noQuizzesFound: 'Nessun test trovato',
      editQuiz: 'Modifica test',
      createQuizSuccess:
        'Test creato con successo. Il test rimarrà in stato di "Bozza" fino a quando non verrà avviato!',
      createQuizError: 'Si è verificato un errore durante la creazione del test. Per favore riprova.',
      participants: 'Partecipanti',
      users: 'Utenti',
      questions: 'Domande',
      selectedQuestionsNumber: 'Numero di domande selezionate',
      validity: 'Validità',
      completed: 'Completati',
      progress: 'Progresso',
      submit: 'Invia',
      submitDraft: 'Test pronto!',
      submitQuizError: "Si è verificato un errore durante l'invio del test. Per favore riprova.",
      quizSubmitSuccess: 'Test inviato con successo. Il test rimarrà in stato "Pronto" fino alla sua data di inizio',
      pause: 'Pausa',
      resume: 'Riattiva',
      pauseQuizError: 'Si è verificato un errore durante la sospensione del test. Per favore riprova.',
      quizPauseSuccess: 'Test sospeso con successo',
      resumeQuizError: 'Si è verificato un errore durante la riattivazione del test. Per favore riprova.',
      quizResumeSuccess: 'Test riattivato con successo',
      changeStartDate: 'Modifica data di inizio',
      forceStart: 'Inizia ora',
      newStartDateTime: 'Nuova data e ora di inizio',
      changeStartDateError:
        'Si è verificato un errore durante la modifica della data e ora di inizio del test. Per favore riprova.',
      changeStartDateSuccess: 'Data e ora di inizio del test modificate con successo',
      confirmForceStart: 'Sei sicuro di voler iniziare il test immediatamente?',
      forceStartError: "Si è verificato un errore durante l'inizio del test. Per favore riprova.",
      forceStartSuccess: 'Test iniziato con successo',
      addNewParticipants: 'Aggiungi nuovi partecipanti',
      newParticipants: 'Nuovi partecipanti',
      addParticipantsSuccess: 'Nuovi partecipanti aggiunti con successo',
      addParticipantsError: "Si è verificato un errore durante l'aggiunta di nuovi partecipanti. Per favore riprova.",
      terminate: 'Termina',
      confirmTerminateQuiz: "Sei sicuro di voler terminare il test immediatamente? L'azione non sarà reversibile.",
      terminateQuizSuccess: 'Test terminato con successo',
      terminateQuizError: 'Si è verificato un errore durante la terminazione del test. Per favore riprova.',
      editQuizSuccess:
        'Test modificato con successo. Il test rimarrà in stato di "Bozza" fino a quando non verrà avviato!',
      editQuizError: 'Si è verificato un errore durante la modifica del test. Per favore riprova.',
      reactivate: 'Riattiva',
      confirmReactivateQuiz: 'Sei sicuro di voler riattivare il test?',
      reactivateQuizSuccess: 'Test riattivato con successo',
      reactivateQuizError: 'Si è verificato un errore durante la riattivazione del test. Per favore riprova.',
      createdBy: 'Responsabile',
      extendQuizSuccess: 'Test esteso con successo',
      extendQuizError:
        "Si è verificato un errore durante l'estensione della data e ora di inizio del test. Per favore riprova.",
      newEndDateTime: 'Nuova data e ora di fine',
      extendExpiration: 'Estendi scadenza',
      confirmDeleteQuiz: 'Sei sicuro di voler eliminare il test?',
      deleteQuizSuccess: 'Test eliminato con successo',
      deleteQuizError: "Si è verificato un errore durante l'eliminazione del test. Per favore riprova.",
      showQuestionsDetails: 'Mostra dettagli domande',
      givenAnswers: 'Risposte completate',
      totalQuestions: 'Domande totali',
      quizStatistics: 'Statistiche',
      userAnswers: 'Mostra risposte',
      sendReminder: 'Invia promemoria',
      sendReminderSuccess: 'Promemoria inviato',
      sendReminderError: 'Invio promemoria fallito',
      hideScoresToUsers: 'Nascondi punteggi ai partecipanti',
      usersCanDownloadReport: 'Gli utenti del test possono scaricare il loro report individuale',
      hideScores: 'Nascondi punteggi',
      downloadReport: 'Download Report',
      hideScoresDescription:
        'Se nascondi i punteggi gli utenti potranno rivedere le proprie risposte al test ma non i punteggi ottenuti',
      downloadReportDescription:
        'Se abiliti l’opzione per il download del report individuale, gli utenti potranno scaricare il proprio report. Tuttavia, se l’opzione ‘Nascondi Punteggi’ è attivata, i partecipanti al quiz non potranno scaricare il loro report.',
      hideScoreAnalyticsDescription: 'I punteggi del test sono nascosti dal supervisore',
      updateHideScoreSuccess: 'Nascondi punteggi modificato con successo',
      updateDownloadReportSuccess: 'Download report modificato con successo',
      updateHideScoreError: 'Si è verificato un errore durante la modifica di nascondi punteggi. Per favore riprova.',
      updateDownloadReportError: 'Si è verificato un errore durante la modifica di download report. Per favore riprova.'
    },
    analytics: {
      userScoresAsc: 'Dal peggiore al migliore',
      userScoresDesc: 'Dal migliore al peggiore',
      valutationRange: 'Range Valutazione',
      order: 'Ordinamento',
      changeView: 'Cambia visualizzazione',
      private: 'Privato e confidenziale',
      filters: 'Filtri',
      subskillsScores: 'Punteggi subskills',
      score: 'Punteggo',
      userScore: 'Punteggio utente',
      skillsScores: 'Punteggi skills',
      analytics: 'Statistiche',
      submissionsTrend: 'Andamento delle submissions',
      usersSubmissions: 'Risposte dei partecipanti',
      noSubmissionStarted: "L'utente non ha risposto al test",
      submissionStillDraft: "L'utente ha iniziato il test ma non ha finalizzato le risposte",
      currentScores: 'Punteggi del test',
      selfAssessmentScores: 'Autovalutazione iniziale',
      userQuizSkillsScore: 'Punteggi utente per il test',
      usersQuizSkillsScore: 'Punteggi utenti',
      skillsTrendChart: 'Grafico andamento delle skills',
      leastPerformingUser: 'Utente peggiore',
      bestPerformingUser: 'Utente migliore',
      skills: 'Skills',
      all: 'Qualsiasi',
      everyone: 'Tutti i partecipanti',
      errorCreateCSV: 'Si è verificato un errore nella creazione del CSV',
      errorCreatePDF: 'Si è verificato un errore nella creazione del PDF',
      chartForUser: "Statistiche dell'utente",
      chartForUserOverTime: "Statistiche dell'utente {{user}} nel tempo",
      chartForUserMean: "Media aggregata dell'utente {{user}}",
      chartMeanOverall: 'Media aggregata delle skills di sistema',
      chartMeanOverTime: "Media aggregata delle skills di sistema nell'intervallo di tempo selezionato",
      overallStatisticsForUser: "Punteggi totali dell'utente {{user}}",
      overallAnalytics: 'Metriche di sistema',
      overallAnalyticsOverTime: 'Andamento skills di sistema',
      overallAnalyticsOverTimeDescription:
        "Questo grafico mostra l'andamento delle skills di sistema nell'intervallo di tempo selezionato",
      currentScoresOfSystem: 'Punteggi attuali di tutti gli utenti',
      summaryDescription: 'Punteggi aggregati di tutti gli utenti della piattaforma per singola skill',
      userSummaryScores: 'Punteggi aggregati per ogni utente',
      userSummaryScoresDescription:
        'Questo grafico mostra per ogni utente la media dei suoi punteggi fino ad ora ottenuti',
      detailedAnalytics: 'Analitiche nel dettaglio',
      usersSkillsScores: 'Punteggi utenti per tutte le skills',
      selectSkillForChart: 'Seleziona la skill per vedere il punteggio degli utenti',
      overallStatisticsForUserDescription: 'Seleziona un utente dai filtri per visualizzarne i dettagli',
      userSkillsScore: 'Punteggio utente',
      usersSkillScores: 'Punteggi utenti per {{skill}}',
      userSummaryBubbleScoresDescription:
        'Questo grafico mostra per ogni classe di punteggio la percentuale di utenti con quel punteggio',
      percentage: 'Percentuale',
      userSummaryBubbleScores: 'Percentuali di utenti per punteggio',
      usersPercentage: 'Percentuale di utenti',
      downloadCsvSuccess: 'Il tuo report è stato inviato. Controlla la tua mail tra qualche minuto'
    },
    submissions: {
      answer: 'Risposta',
      submissionLoadFailed: 'Si è verificato un errore nel caricamento del test',
      pleaseReload: 'Per favore, ricarica il test.',
      submissionsFor: 'Le risposte al test {{quizName}}',
      closedAt: 'sono state chiuse il',
      arePaused: 'sono sospese.',
      waitForSupervisor: 'Attendi ulteriori istruzioni dal supervisor del test',
      willStart: 'inizieranno',
      soon: 'presto',
      areOpen: 'sono aperte',
      startNewSubmission: 'inizia il test',
      noAnswerSelectedError: 'Per favore, seleziona una delle opzioni.',
      submitAnswer: 'Invia risposta',
      concludeQuiz: 'Concludi test',
      answerSubmitSuccess: 'Risposta inviata con successo',
      answerSubmitError: "Si è verificato un errore durante l'invio della risposta. Per favore riprova.",
      quizSubmitted: 'Test inviato',
      submissionSubmitSuccess: 'Test concluso!',
      submissionSubmitError: 'Si è verificato un errore durante la chiusura del test. Per favore riprova.',
      sybmissionGuidelinesSmartWorking:
        'Con il termine “Smart Working” intendiamo lo svolgimento del proprio lavoro ovunque indipendentemente da dove ci si trovi e dalla localizzazione geografica, anche se esso può avvenire prevalentemente da casa. Questa definizione comprende anche la terminologia “lavoro da remoto” attraverso l’utilizzo delle tecnologie della comunicazione come ad esempio, PC, internet, email, sistemi di videoconferenza. per la realizzazione dei quotidiani compiti lavorativi e per lavorare con colleghi in team virtuali/online. (Smarter Working Guide, 2007)',
      submissionCompleted: 'Hai risposto a tutte le domande! Invia le tue risposte per terminare il test',
      noSubmissionSendQuizDone: 'Non hai inviato le tue risposte a questo test!',
      submissionsRefusedNoCredits:
        'La tua istituzione non può accettare nuove rispose. Per favore contatta il tuo responsabile',
      title:
        'Edulai Skills Checker valuta il livello di alcune tue Skills, strumenti chiave per affrontare oggi le sfide del mercato del lavoro.',
      description1:
        'Ti presenteremo diversi casi professionali concreti da leggere con attenzione. Ogni caso descrive una situazione specifica e dovrai scegliere, tra le risposte/soluzioni fornite, quella che ritieni più opportuna per quello specifico caso. Non pensarci troppo. Non esistono risposte giuste o sbagliate. Sono solo approcci diversi che ci aiutano a definire meglio le tue competenze.',
      description2:
        'La compilazione dello Skills Checker richiede tra i 15 e i 20 minuti. Le risposte devono essere fornite nella sequenza proposta. Non puoi saltarle né muoverti avanti e indietro tra le domande. Il test deve essere completato tutto in una volta, ma se problemi tecnici ti impedissero di completarlo avrai la possibilità di accedere nuovamente e di inviare le risposte mancanti. Una volta completate tutte le risposte, il sistema ti mostrerà i risultati e potrai accedere sia a un report più generale che a uno più specifico sullo sviluppo dei tuoi Skills. Ti saranno inoltre fornite le linee guida per interpretare al meglio i risultati. La valutazione di Edulai Skills Checker può essere eseguita una sola volta o anche più volte nell’arco di un dato periodo, così che lo sviluppo di una o più competenze possano essere monitorate nel tempo.',
      description3:
        'Il futuro del lavoro è già qui. Sveliamo il tuo potenziale inespresso: accetta la sfida, risolvi i nostri casi e scopri, una ad una, le soft skill e le capacità digitali che ti renderanno insostituibile domani.',
      question: 'Caso',
      options: 'Opzioni',
      option: 'Opzione',
      all: 'Tutto',
      message_1: 'Complimenti!<br/> Hai risolto già i primi casi! Continua così e presto saprai molte cose su di te!',
      message_2:
        'Congratulazioni!<br/> Ti sei messo in gioco in questi altri casi! Ciò ti ha richiesto un pò di attenzione e di riflessione personale, ma ne è valsa la pena! Grande! Non mollare e presto vedrai i tuoi risultati!',
      message_3:
        'Ora hai oltrepassato la metà del tuo percorso!<br/> Non tutti arrivano fino a qui! Complimenti perchè dimostri buona costanza e ottima volonta! Ci sei quasi!',
      message_4:
        'Wow!!<br/> Sei quasi alla fine! Una volta concluso il test avrai tanti suggerimenti utili che ti aiuteranno a conoscerti meglio, senza giudizi di sorta, ma con la sola volontà di potenziare le tue competenze!',
      message_end:
        'Vivissime congratulazioni!<br/> Sei arrivato alla fine del percorso! Che soddisfazione! Sei grande! Ora potrai conoscere le tue competenze una ad una (e ti assicuro che non tutti le conoscono) e soprattutto sapere che cosa fare per migliorarle! Per questo meriti in premio! Ti sei guadagnato il nostro badge digitale Edulai per aver acquisito maggior consapevolezza sulle tue competenze. Scarica qui il badge in formato PDF.',
      button: 'prosegui',
      buttonEnd: 'Vedi risultati',
      downloadBadge: 'Scarica il badge',
      showAllText: 'Mostra tutto subito'
    },
    chat: {
      messageError: 'Si è verification un errore, per favore, riprova.',
      askAI: 'Chiedi a Edulai Coach AI',
      coachAIMessage: `Sono il **Coach AI di Edulai** e sono qui per aiutarti a sviluppare le tue *skills*.
- Fammi domande sui risultati del tuo test: posso analizzarlo e mostrarti punti di forza, punti di debolezza e aree di miglioramento, con punteggi, suggerimenti e commenti utili.
- Fammi domande per migliorare le tue *skills* carenti e potenziare quelle forti: posso fornirti suggerimenti e consigli interessanti.
- Chiedimi risorse da leggere, ascoltare o guardare per migliorare le tue competenze; posso suggerirtene anche in base al tuo livello.`,
      coachAIPrompt:
        "Commenta i risultati del quiz {{ id }}. Non nominare l'ID del quiz nella risposta; rispondi anche se hai già risposto. Rispondi in {{ language }}",
      retry: 'Invia di nuovo l’ultima domanda effettuata'
    }
  }
};
